import { enableProdMode, importProvidersFrom, APP_INITIALIZER, provideZoneChangeDetection } from '@angular/core'
import { environment } from './environments/environment'
import { defineCustomElements } from '@ionic/pwa-elements/loader'
import { RouteReuseStrategy } from '@angular/router'
import { IonicRouteStrategy, IonicModule } from '@ionic/angular'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpClient, withXhr } from '@angular/common/http'
import { InterceptorApi, INT_DEFAULT_TIMEOUT } from './app/services/interceptor-api.service'
import { AppRoutingModule } from './app/app-routing.module'
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser'
import { TranslateModule, TranslateLoader, TranslateCompiler } from '@ngx-translate/core'
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler'
import { ServiceWorkerModule } from '@angular/service-worker'
import { AppComponent } from './app/app.component'
import { ConfigBackupService } from './app/services/config-backup.service'

// Import Capacitor plugins
import { SplashScreen } from '@capacitor/splash-screen'
import { StatusBar, Style } from '@capacitor/status-bar'
import { HttpLoaderFactory } from './app/app.module'

if (environment.production) {
  enableProdMode()
}

// Bootstrap the application
bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      AppRoutingModule,
      BrowserModule,
      IonicModule.forRoot({
        mode: 'md',
        scrollAssist: false,
        innerHTMLTemplatesEnabled: true
      }),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        },
        compiler: {
          provide: TranslateCompiler,
          useClass: TranslateMessageFormatCompiler
        }
      }),
      ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.serviceWorker })
    ),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorApi, multi: true },
    { provide: INT_DEFAULT_TIMEOUT, useValue: 10000 },
    {
      provide: APP_INITIALIZER,
      useFactory: (configBackup: ConfigBackupService) => () => configBackup.restoreConfig(),
      deps: [ConfigBackupService],
      multi: true
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
})
  .then(() => {
    // Configure StatusBar and SplashScreen after the platform is ready
    StatusBar.setStyle({ style: Style.Dark }).catch((err) =>
      console.warn('Error setting StatusBar style:', err)
    )
    SplashScreen.hide().catch((err) =>
      console.warn('Error hiding SplashScreen:', err)
    )
  })
  .catch((err) => console.log(err))

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window)
